import BillingModel from "../../../../types/billing-model";
import BillingStatus from "../../../../types/billing-status";

export type BillingsCargoTaxiDetailsContractCargoCompany = {
  companyName: string;
  displayName: string;
};

export type BillingsCargoTaxiDetailsContract = {
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
  cargoCompany: BillingsCargoTaxiDetailsContractCargoCompany;
  model: BillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
};

export type BillingsCargoTaxiDetailsBillingNode = {
  uuid: string;
  nodeUuid: string;
  checkoutEventUuid?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinates: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export type BillingsCargoTaxiDetailsCargoOrder = {
  uuid: string;
  humanId: number;
};

export enum BillingsCargoTaxiDetailsBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsCargoTaxiDetailsBillingContributionBaseAmount = {
  type: BillingsCargoTaxiDetailsBillingContributionType.BASE_AMOUNT;
  comment?: string;
  distance: number;
  rate: number;
};

export type BillingsCargoTaxiDetailsBillingContributionChargeHaltings = {
  type: BillingsCargoTaxiDetailsBillingContributionType.CHARGE_HALTING;
  comment?: string;
  distance: number;
  amount: number;
};

export type BillingsCargoTaxiDetailsBillingContributionContractCorrectionPercentage =
  {
    type: BillingsCargoTaxiDetailsBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsCargoTaxiDetailsBillingContributionDiscountOptimization = {
  type: BillingsCargoTaxiDetailsBillingContributionType.DISCOUNT_OPTIMIZATION;
  comment?: string;
  amount: number;
};

export type BillingsCargoTaxiDetailsBillingContributionDiscountBeingLate = {
  type: BillingsCargoTaxiDetailsBillingContributionType.DISCOUNT_BEING_LATE;
  comment?: string;
  amount: number;
};

export type BillingsCargoTaxiDetailsBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsCargoTaxiDetailsBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiDetailsBillingContributionDiscountOther = {
  type: BillingsCargoTaxiDetailsBillingContributionType.DISCOUNT_OTHER;
  comment?: string;
  amount: number;
};

export type BillingsCargoTaxiDetailsBillingContribution =
  | BillingsCargoTaxiDetailsBillingContributionBaseAmount
  | BillingsCargoTaxiDetailsBillingContributionChargeHaltings
  | BillingsCargoTaxiDetailsBillingContributionContractCorrectionPercentage
  | BillingsCargoTaxiDetailsBillingContributionDiscountOptimization
  | BillingsCargoTaxiDetailsBillingContributionDiscountBeingLate
  | BillingsCargoTaxiDetailsBillingContributionDiscountIncompatibleCar
  | BillingsCargoTaxiDetailsBillingContributionDiscountOther;

type BillingsCargoTaxiDetails = {
  status: BillingStatus;
  passengers: string[];
  contract: BillingsCargoTaxiDetailsContract;
  baseAmountValue: number;
  amountForChargeHighways: number;
  amountForChargeHaltings: number;
  contractCorrectionPercentage: number;
  sumOfDiscounts: number;
  amountForDistance: number;
  allContributionsAmount: number;
  distance: number;
  date: Date;
  billingNodes: BillingsCargoTaxiDetailsBillingNode[];
  cargoOrder: BillingsCargoTaxiDetailsCargoOrder;
  planEntryUuid: string;
  billingContributions: BillingsCargoTaxiDetailsBillingContribution[];
};

export default BillingsCargoTaxiDetails;
